import ApiResponse from '~/graphql/wrappers/api-response';
import {
  type TypedDocumentNode,
  useClientHandle,
  type UseMutationResponse,
  type UseQueryArgs,
  type UseQueryResponse,
} from '@urql/vue';

export abstract class ApiCall<T = Mutation | Query, V = any> {
  private urql = useClientHandle();

  abstract run(input: V): Promise<ApiResponse<T>>;

  protected createQuery(args: UseQueryArgs<T, V>): UseQueryResponse<T, V> {
    return this.urql.useQuery(args);
  }

  protected createMutation(
    mutationDocument: TypedDocumentNode<T, V>,
  ): UseMutationResponse<T, V> {
    return this.urql.useMutation(mutationDocument);
  }
}
